import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHotline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 45" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#979797"
      transform="translate(1 1)"
    >
      <ellipse cx={24} cy={22.5} rx={24} ry={20.5} />
      <ellipse cx={24} cy={22} rx={10} ry={9} />
      <path d="M15.265 17.185c-2.676-2.902-6.507-4.84-11.49-5.815m28.961 6.025c2.703-3.638 6.39-5.813 11.063-6.527m-20.158 2.023V1.837M4 33.929c2.637-3.845 6.446-6.23 11.426-7.157m28.108 7.553C40.876 30.378 37.032 27.936 32 27M30.546 2.757C31.36.427 32.588-.29 34.229.607c2.461 1.346 1.194 2.8 4.162 3.783 2.969.984 5.568-.288 5.61 1.768.027 1.37-.416 2.412-1.33 3.126M14.289 3.383C13.158 1.19 11.842.65 10.342 1.767c-2.25 1.675-.792 2.938-3.595 4.325s-5.554.49-5.309 2.531c.164 1.361.748 2.331 1.752 2.91" />
    </g>
  </svg>
);
const Memo = memo(SvgHotline);
export default Memo;
